export default function LoadingInner() {
  return (
    <div className="relative w-full h-full">
      <div className="flex items-center justify-center bg-gray-100 dark:bg-dark-charcoal h-full">
        <div className="text-center">
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
